export const initState = {
  placementSettings: [],
}
